window._ = require('lodash');

try {
  window.$ = window.jQuery = require('jquery');
  require('bootstrap');
} catch (e) { }
/*
Array.prototype.toString = function(){
  return this.map(e=>e.toString()).join(', ')
}
Object.prototype.toString = function(){
  return Object.keys(this).map(k=>k+': '+this[k]).join(', ')
}
*/

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
  window._csrf_token = token.content
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

$(function () {
  var input = $('#search-employee-input');
  var container = $('#search-employee-box');
  var results = [];
  var nextResults = null;
  var hidder = null;
  var isOver = false;
  var lastSearchKey = null;

  function hideContainer() {
    if (hidder) clearTimeout(hidder);

    hidder = setTimeout(function () {
      container.addClass('d-none');
      hidder = null;
    }, 3000);
  }

  function setLoading() {
    $('#ow-employee-search-icon').addClass('d-none');
    $('#ow-employee-searching-icon').removeClass('d-none');
  }

  function setLoaded() {
    $('#ow-employee-search-icon').removeClass('d-none');
    $('#ow-employee-searching-icon').addClass('d-none');
  }

  function createItem(item) {
    var template = `
    <li class="list-group-item border-0 p-0">
      <a class="employee-search-item text-decoration-none text-ow-secondary" href="/employees/${item.id}">
        <img src="${item.avatar_full_path}" class="rounded-circle w-6 h-6 mr-2" alt=""/>
        <span>${item.names} ${item.first_surname} ${item.alias ? '(' + item.alias + ')': ''}</span>
      </a>
    </li>`;
    
    return $(template);
  }

  function createNextItem() {
    var template = '<li class="list-group-item border-0 text-center" id="loadMoreEmployees"><button type="button" class="btn btn-ow-secondary">Cargar más</button></li>';
    return template;
  }

  function createEmpty() {
    return $('<div class="p-4 text-center text-ow-primary">No hay resultados por mostrar.</div>')
  }

  container.on('mouseenter', function () {
    isOver = true;
  })

  container.on('mouseleave', function () {
    isOver = false;
  })

  input.on('focus', function (event) {
    if (results.length > 0) {
      container.removeClass('d-none');
    }
  })

  input.on('blur', function (event) {
    if (results.length > 0 && !isOver) {
      container.addClass('d-none');
    }
  })

  var cancelSearch = null;
  var searchSequence = 0;

  var debouncedSearch = _.debounce(function (value, withTrashed) {
    setLoading();

    if (cancelSearch) cancelSearch();

    var currentSearch = ++searchSequence;

    axios.get('/employees', {
      params: {
        quickSearch: value,
        withTrashed: withTrashed
      },
      cancelToken: new axios.CancelToken(function executor(c) {
        cancelSearch = c;
      })
    })
      .then(resp => {
        // this.errorMessage = null;
        // this.cancelSearch = null;
        results = resp.data.data.map(e => {
          e.identify_group = e.identify_group != null ? "(" + e.identify_group + ")" : ''
          return e;
        })
        nextResults = resp.data.next_page_url

        container.empty();
        container.removeClass('d-none');
        if (results.length > 0) {
          if (hidder) clearTimeout(hidder);

          var list = $('<ul class="list-group"></ul>');
          results.forEach(function (item) {
            list.append(createItem(item));
          })

          if (nextResults) {
            list.append(createNextItem());
          }

          container.append(list)
        } else {
          container.append(createEmpty())

          hideContainer()
        }

      })
      .catch(resp => {
        if (axios.isCancel(resp)) {
        } else {
          // alert("No fue posible actualizar los empleados")
          var errorMessage = 'Vuelva a realizar la busqueda.';
          console.log(resp)
        }
      })
      .finally(() => {
        if (currentSearch === searchSequence) setLoaded();
      })
  }, 500);

  // Only hit the endpoint when the effective query actually changes.
  // Key events like arrows, tab or modifiers leave the value untouched.
  function requestSearch(force) {
    var value = input.val().trim();
    var withTrashed = $('#with-trashed-search-employee').is(':checked');
    var searchKey = value + '|' + withTrashed;

    if (value.length < 2) {
      lastSearchKey = null;
      return;
    }

    if (!force && searchKey === lastSearchKey) {
      return;
    }

    lastSearchKey = searchKey;
    debouncedSearch(value, withTrashed);
  }

  input.on('input', function () {
    requestSearch(false);
  });

  $('#with-trashed-search-employee').on('change', function () {
    requestSearch(false);
  });

  $(document).on('click', '#loadMoreEmployees', function () {
    setLoading();
    axios.get(nextResults)
      .then(function (resp) {
        results = resp.data.data.map(e => {
          e.identify_group = e.identify_group != null ? "(" + e.identify_group + ")" : ''
          return e;
        })
        nextResults = resp.data.next_page_url

        // container.empty();
        container.removeClass('d-none');
        if (results.length > 0) {
          container.find('#loadMoreEmployees').remove();

          if (hidder) clearTimeout(hidder);

          var list = container.find('.list-group');
          results.forEach(function (item) {
            list.append(createItem(item));
          })

          if (nextResults) {
            list.append(createNextItem());
          } else {

          }
        }
      })
      .catch(resp => {
        if (axios.isCancel(resp)) {
        } else {
          // alert("No fue posible actualizar los empleados")
          var errorMessage = 'Vuelva a realizar la busqueda.';
          console.log(resp)
        }
      })
      .finally(() => {
        setLoaded();
      })
  })
});
